import { JSONSchema7 } from "json-schema";

export type BrowserSkillParameters = {
  type: "browser";
  start_url: string;
  profile_name?: string | null;
  input_schema: {
    type: "object";
    properties: {
      instructions: {
        type: "string";
        description: string;
      };
    };
    required?: string[];
  };
};

export type SkillParameters = JSONSchema7 | BrowserSkillParameters;

export interface Skill {
  id: string;
  name: string;
  description: string;
  quackUsage: number;
  curl: string;
  slug: string;
  parameters?: SkillParameters;
  type?: string;
  requiresApproval: boolean;
  responseFields?: string[] | null;
  sampleResponse?: unknown;
}

export function buildSkillSlug(name: string) {
  return name.toLowerCase().replace(/ /g, "_");
}

export function isBrowserSkill(
  skill: Skill
): skill is Skill & { parameters: BrowserSkillParameters } {
  return (skill.parameters as BrowserSkillParameters | undefined)?.type === "browser";
}

export function buildBrowserSkillParameters(
  startUrl: string,
  profileName?: string | null
): BrowserSkillParameters {
  const parameters: BrowserSkillParameters = {
    type: "browser",
    start_url: startUrl,
    input_schema: {
      type: "object",
      properties: {
        instructions: {
          type: "string",
          description: "What to do on the page once loaded",
        },
      },
      required: ["instructions"],
    },
  };

  if (profileName) {
    parameters.profile_name = profileName;
  }

  return parameters;
}

export function getBrowserSkillConfig(skill: Skill): {
  startUrl: string;
  requiresAuthentication: boolean;
  profileName?: string | null;
} {
  if (!isBrowserSkill(skill)) {
    return {
      startUrl: "",
      requiresAuthentication: false,
      profileName: undefined,
    };
  }

  const { start_url, profile_name } = skill.parameters;

  return {
    startUrl: start_url,
    requiresAuthentication: Boolean(profile_name),
    profileName: profile_name,
  };
}
